import { Link } from "react-router-dom";

import ShowAllIcon from "@mui/icons-material/FormatListBulletedRounded";
import { Box, IconButton, Typography } from "@mui/material";

import { CounselorSelect } from "@/common/components/counselor-select/CounselorSelect";
import { AppRoutes } from "@/router/AppRoutes";
import { useTranslation } from "@/translations";

interface Props {
  count: number;
  currentCounselorId: string | undefined;
  selectedCounselorId: string | null;
  onCounselorChange: (counselorId: string | null) => void;
}

export function PriorityRequestsHeader({ count, currentCounselorId, selectedCounselorId, onCounselorChange }: Props) {
  const { t } = useTranslation();

  return (
    <Box
      px={2}
      py={0.5}
      bgcolor={"fsw.blue-5"}
      justifyContent={"space-between"}
      display={"flex"}
      alignItems={"center"}
      gap={2}
    >
      <Typography variant="h6" whiteSpace={"nowrap"}>
        {t("priorityRequests.widget.title", { count })}
      </Typography>
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <CounselorSelect
          selectedCounselor={selectedCounselorId}
          onSelectCounselor={onCounselorChange}
          allOptionLabel={t("priorityRequests.filter.allCounselors")}
          onlyCounselorIds={currentCounselorId ? [currentCounselorId] : []}
          ariaLabel={t("priorityRequests.widget.counselor")}
        />
        <IconButton aria-label={t("priorityRequests.widget.showAll")} component={Link} to={AppRoutes.PriorityRequests}>
          <ShowAllIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
